import { AdaptiveWidth, Card, FlowBox, HorizBox, HoverSelectBox, HoverView, PadBox, ShadowBox, VertBox } from 'component/basics';
import { CTAButton, Tag } from 'component/button';
import { NewPublicFooter } from 'component/screen';
import { UtilityText } from 'component/text';
import { useEffect, useState } from 'react';
import { View } from 'react-native';
import { CHECK_TEXT, CLICK, component, componentWithVariants, DemoBox, demoFile, HOVER, story, variant } from 'system/demo';

demoFile('component/basics');

const ShadowBoxDemo = () => (
    <ShadowBox>
        <PadBox horiz={20} vert={20}>
            <UtilityText text='Shadow Box' />
        </PadBox>
    </ShadowBox>
);
component('ShadowBox', ShadowBoxDemo);
function FlowBoxDemo({ rowGap = 10, columnGap = 20 }) {
    const [center, setCenter] = useState(false);
    return (
        <VertBox gap={8}>
            <CTAButton onPress={() => setCenter(!center)} testID='toggle-flow-center' text='Toggle Center' />
            <UtilityText testID='flow-layout' text={center ? 'centered' : 'left'} />
            <FlowBox center={center} columnGap={columnGap} rowGap={rowGap}>
                <Tag text='This is Item One' />
                <Tag text='This is Item Two' />
                <Tag text='This is Item Three' />
                <Tag text='This is Item Four' />
                <Tag text='This is Item Five' />
            </FlowBox>
        </VertBox>
    );
}

component(
    'FlowBox',
    FlowBoxDemo,
    {
        args: { rowGap: 10, columnGap: 20 },
    },
    [story('Toggle Center', [CLICK('toggle-flow-center'), CHECK_TEXT('centered')])],
);

function HorizBoxDemo({ gap = 0 }) {
    const [spread, setSpread] = useState(false);
    return (
        <VertBox gap={8}>
            <CTAButton onPress={() => setSpread(!spread)} testID='toggle-horiz-spread' text='Toggle Spread' />
            <UtilityText testID='horiz-layout' text={spread ? 'spread' : 'normal'} />
            <HorizBox gap={gap} spread={spread}>
                <Tag text='Item One' />
                <Tag text='Item Two next to it' />
                <Tag text='Item Three' />
            </HorizBox>
        </VertBox>
    );
}

componentWithVariants('HorizBox', HorizBoxDemo, {}, [
    variant('Default', {}, [story('Toggle Spread', [CLICK('toggle-horiz-spread'), CHECK_TEXT('spread')])]),
    variant('Gap 4', { args: { gap: 4 } }, []),
]);

const CardDemo = () => (
    <Card>
        <UtilityText text='I am in a card' />
    </Card>
);
component('Card', CardDemo);

component('NewPublicFooter', NewPublicFooter, { siloKey: 'np' });

function AdaptiveWidthDemo() {
    const [narrow, setNarrow] = useState(false);
    const [wide, setWide] = useState(true);
    const width = wide ? 400 : 200;
    useEffect(() => {
        setNarrow(width < 300);
    }, [width]);
    return (
        <VertBox gap={8}>
            <CTAButton onPress={() => setWide(!wide)} testID='toggle-width' text='Toggle Width' />
            <View style={{ width }}>
                <AdaptiveWidth breakpoint={300} setNarrow={setNarrow}>
                    <UtilityText testID='width-label' text={narrow ? 'Narrow' : 'Wide'} />
                </AdaptiveWidth>
            </View>
        </VertBox>
    );
}

component('AdaptiveWidth', AdaptiveWidthDemo, {}, [
    story('Shrink then Expand', [
        CHECK_TEXT('Wide'),
        CLICK('toggle-width'),
        CHECK_TEXT('Narrow'),
        CLICK('toggle-width'),
        CHECK_TEXT('Wide'),
    ]),
]);

function HoverViewDemo() {
    const [hover, setHover] = useState(false);
    return (
        <HoverView hoverStyle={{ backgroundColor: '#eee' }} onPress={() => {}} setHover={setHover} testID='hover-view'>
            <UtilityText testID='hover-text' text={hover ? 'Hovering' : 'Idle'} />
        </HoverView>
    );
}

component('HoverView', HoverViewDemo, {}, [story('Hover', [HOVER('hover-view'), CHECK_TEXT('Hovering')])]);

function HoverSelectBoxDemo() {
    const [selected, setSelected] = useState(false);
    return (
        <HoverSelectBox onPress={() => setSelected(true)} selected={selected} testID='hover-select'>
            <UtilityText text={selected ? 'Selected' : 'Not Selected'} />
        </HoverSelectBox>
    );
}

component('HoverSelectBox', HoverSelectBoxDemo, {}, [story('Select', [CLICK('hover-select'), CHECK_TEXT('Selected')])]);
